import React from 'react';
import './LoadingIndicator.scss';

export interface Props {
    show?: boolean;
    /**size in pixels, defaults to 14 */
    size?: number;
}

export const LoadingIndicator: React.FC<Props> = (p) => {
    if (!p.show) return null;

    const size = Math.min(p.size || 14, 8) + 'px';
    const containerMeasurement = Math.min(p.size || 14, 8) * 3;
    const containerSize = containerMeasurement + 'px'; 

    const bounceStyle = {
        width: size,
        height: size
    }

    const containerStyle = {
        width: containerSize,
        marginLeft: '-' + (containerMeasurement + 6) + 'px'
    }

    return (
        <div className="spinner" style={containerStyle}>
            <div className="bounce1" style={bounceStyle}></div>
            <div className="bounce2" style={bounceStyle}></div>
            <div className="bounce3" style={bounceStyle}></div>
        </div>
    )
}